export const Wordmark = ({ className = "", size = "base", tagline = false, onClick }) => {
  const sizes = {
    sm: "text-lg",
    base: "text-xl md:text-2xl",
    lg: "text-3xl md:text-4xl",
    xl: "text-4xl md:text-6xl",
  };
  return (
    <div className={`flex flex-col leading-none ${className}`} onClick={onClick}>
      <span className={`font-serif font-medium text-wine ${sizes[size]}`}>
        The Thrive <span className="italic font-normal text-terracotta">&amp;</span> Mother Company
        <sup className="text-[0.5em] align-super ml-0.5">™</sup>
      </span>
      {tagline && (
        <span className="mt-2 text-[0.6rem] md:text-xs uppercase tracking-[0.35em] text-terracotta font-sans font-medium">
          Motherhood Is Leadership™
        </span>
      )}
    </div>
  );
};
